module.exports = __webpack_public_path__ + "static/media/DecIdBack.catalyst.a49ebce4.tsx";